/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Form/view.blocks to change it.
import Address from './Address/index'
import AppointmentReminders from './AppointmentReminders/index'
import Description from './Description/index'
import React from 'react'
import SendNextAppointmentReminder from './SendNextAppointmentReminder/index'



/** @type {import('Simple/types.js').View} */
export default function Form({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/NewEmail/Content/Content/Form"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Form.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Address
  viewPath={`${viewPath}/Address`}
/>
<Description
  viewPath={`${viewPath}/Description`}
/>
<AppointmentReminders
  viewPath={`${viewPath}/AppointmentReminders`}
/>
<SendNextAppointmentReminder
  viewPath={`${viewPath}/SendNextAppointmentReminder`}
/>
</div>
{children}
</React.Fragment>)
}